// Define the function to use
export default function (data) {
  // Redirect the user using this data
  window.open(data.url, "_blank")
}
